import React, { Fragment, useState } from 'react'
import { Button, Input, H1, Label, Div, P, Span } from '@driftt/tide-core'
import { UploadArea } from '@driftt/tide-file-upload'
import { api } from 'modules/user/api'
import config from 'config'
import OnboardingFooter from 'components/OnboardingFooter'

import UIDropArea from 'components/UIDropArea'
import DropZone from 'react-dropzone'

import './style.css'

export const BasicProfileStep = ({
  onNameChange,
  name,
  user
}) => {
  const [currentAvatarUrl, setCurrentAvatarUrl] = useState(null)
  const [uploadError, setUploadError] = useState(null)
  const [redirectLoading, setRedirectLoading] = useState(false)

  const onLogoSizeError = () => setUploadError('Your logo exceeds our maximum file size of 20MB')
  const onLogoTypeError = () => setUploadError('Your logo type is not supported')
  const onLogoReadError = () => setUploadError('We couldn’t read the file. Please try again.')

  const onContinue = () => {
    setRedirectLoading(true)
    api.setName(user.userId, {name: user.name})
    if (window.location.pathname.includes("playbooks")) {
      window.location.replace(`${config.CUSTOMER_WEB_URL}/playbooks/list/chat?playbook_editor_onboarded=true`)
    } else if (window.location.pathname.includes("reporting")) {
      window.location.replace(`${config.CUSTOMER_WEB_URL}?reporting_user_onboarded=true`)
    }
    setRedirectLoading(false)
  }

  const uploadAvatar = file => {
    return new Promise((resolve, reject) => {
      api.uploadUserAvatar(user.userId, file)
        .then(response => {
          resolve({ downloadUrl: response.avatarUrl })
        })
        .catch(reject)
    })
  }

  return (
    <Fragment>
      <H1 className="profile-step-header" >Introduce yourself</H1>
      <Input
        required
        value={name}
        onChange={onNameChange}
        label="Your name"
        placeholder="Michael Scott"
        className="full-width-component"
      />
      <Fragment>
        <Label className="full-width-component">
          Your avatar
        </Label>
        <UploadArea
          className="basic-profile-step-upload-area"
          onSizeError={onLogoSizeError}
          onTypeError={onLogoTypeError}
          onReadError={onLogoReadError}
          handleUploadFile={uploadAvatar}
          handleSaveFile={setCurrentAvatarUrl}
          previewUrl={currentAvatarUrl}
        />
        { uploadError && <Span className="profile-photo-upload-step-error">{uploadError}</Span> }
      </Fragment>
      <OnboardingFooter isLoading={redirectLoading} nextFunction={onContinue} />
    </Fragment>
  )
}

export const ProfilePhotoStep = ({
  onDrop,
  user,
  profile,
  isUploadingCoverPhoto,
  onContinueClick,
  onSkipClick,
  onNameChange,
  name,
  isRepInvitedFlow,
  isSSOProvisionedFlow,
  stagedProfilePicture
}) => {
  return (
    <Fragment>
      <H1>Personalize your Conversational Sales Profile</H1>
      <P>Your Drift Profile is your digital business card where people can book meetings and chat in real time with you.</P>
      <Input
        required
        value={name}
        onChange={onNameChange}
        label="What's your name?"
        placeholder="Michael Scott"
        className="full-width-component"
      />
      <UIDropArea user={user} profile={profile} stagedProfilePicture={stagedProfilePicture} uploadAvatar={onDrop} isUploadingCoverPhoto={isUploadingCoverPhoto}/>
      <Div className='continue-button'>
        <Button onClick={onContinueClick}>{
          isSSOProvisionedFlow ? 'Continue to Meetings' :
          isRepInvitedFlow ? 'Continue to your Password' :
          'Continue to Profile Color'
        }</Button>
      </Div>
    </Fragment>
  )
}

export const AEProfilePhotoStep = ({
  onDrop,
  onContinueClick,
  onSkipClick,
  onNameChange,
  name,
  isRepInvitedFlow,
  isSSOProvisionedFlow,
  avatarUrl,
}) => {
  return (
    <Fragment>
      <h1>Introduce yourself&nbsp;<span role="img" aria-label="wave" className="header-text-emoji">👋</span></h1>
      <p>When a teammate books a meeting for you, let them know who they&rsquo;ll be meeting with.</p>
      <Input
        className="full-width-component"
        label="Your name"
        placeholder="Chelsea Ward"
        value={name}
        onChange={onNameChange}
        size="large"
      />
      <Fragment>
        <label className="full-width-component">
          Your avatar
        </label>
        <DropZone
          className='profile-avatar'
          onDrop={onDrop}
        >
          <div style={{ backgroundImage: `url(${avatarUrl})` }} className="profile-photo" />
          <div className="profile-avatar-description">Drag and Drop or <span className="profile-avatar-text">Choose a file</span> to upload</div>
        </DropZone>
      </Fragment>
      <div className="continue-button full-width-component">
        <Button 
          type="primary" 
          size="large" 
          onClick={onContinueClick}
          disabled={!name}
          >
          Continue
        </Button>
      </div>
    </Fragment>
  )
}
